import { useQuery } from '@tanstack/react-query'

import { ApiUrlPath, X_AUTH_TOKEN, IQuestion, AppMsg } from 'cat-shared/utils'
import { fetch, getAbortController, getLocalAuthUser } from 'client/services'

export type TGetQuestionData = {
  count: {
    total: number
  }
  data: IQuestion[]
}

type TError = {
  msg: AppMsg
}

export default (id: string) => {
  const getQuestion = async () => {
    const token = getLocalAuthUser().token

    const abortController = getAbortController(25)

    const url = `${ApiUrlPath.GetQuestion}?${new URLSearchParams({ _id: String(id) })}`

    const res = await fetch(
      url,
      {
        headers: { 'Content-Type': 'application/json', [X_AUTH_TOKEN]: token || '' },
        signal: abortController.signal,
      },
      200
    )

    abortController.clear()

    if (res.ok) {
      const body = (await res.json()) as TGetQuestionData
      return Promise.resolve(body)
    } else {
      const err = (await res.json()) as TError
      return Promise.reject(err)
    }
  }

  return useQuery<TGetQuestionData, TError>([ApiUrlPath.GetQuestion, id], getQuestion, {
    enabled: false,
    keepPreviousData: false,
    cacheTime: 0,
  })
}
